<template>
  <div class="content">
    <h1 class="content__title">Portafolio</h1>
    <span class="content__details">Listado entradas del portafolio</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de entradas</h2>
          <div class="main__results">
            <div class="result" v-if="portfolio === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!portfolio">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <entry-component @update="getPorfolio" v-else v-for="(entry, index) in portfolio" :key="index" :entry="entry" :markets="markets" :sectors="sectors"></entry-component>

          </div>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <button class="btn btn--small btn__default" @click.prevent="newEntry">Nueva entrada</button>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from "@/api/request";
import entryComponent from "./entry";
export default {
  mixins: [httpService],
  components: {
    entryComponent
  },
  data: function() {
    return {
      portfolio: "loading",
      markets: null,
      sectors: null
    };
  },
  created: function() {
    this.getPorfolio();
    this.getMarkets();
    this.getSectors();
  },
  methods: {
    getPorfolio: function() {
      let httpRequest = {
        module: "portfolio",
        params: ""
      };
      this.get(httpRequest)
        .then(portfolio => {
          this.portfolio = portfolio.data;
        })
        .catch(() => {
          this.portfolio = [];
        });
    },
    getMarkets: function() {
      let httpRequest = {
        module: "markets",
        params: ""
      };
      this.get(httpRequest)
        .then(markets => {
          this.markets = markets.data;
        })
        .catch(() => {
          this.markets = null;
        });
    },
    getSectors: function() {
      let httpRequest = {
        module: "sectors",
        params: ""
      };
      this.get(httpRequest)
        .then(sectors => {
          this.sectors = sectors.data;
        })
        .catch(() => {
          this.sectors = null;
        });
    },
    newEntry: function() {
      this.portfolio.push({
        market_id: null,
        sector_id: null,
        industry: null,
        position_id: null,
        portfolio: null
      });
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/portfolio/list.vue